module.exports = __webpack_public_path__ + "static/img/card_07@2x.6d2c84d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card_07@2x.png
// module id = hk6l
// module chunks = 0